// import { io } from "socket.io-client";
// export const useSocket = () => {
//     const socketServerUrl = process.env.REACT_APP_API;
//     const socket = io(socketServerUrl, {
//         transports: ["websocket"]
//     });

//     socket.on('connect', () => {});
//     return {
//         socket
//     };
// }

import { useEffect, useState } from "react";
import { io, Socket } from "socket.io-client";

export const useSocket = () => {
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    const newSocket = io(process.env.REACT_APP_API as string, {
      transports: ["websocket"],
    });

    // newSocket.on("connect", () => {
    //   console.log(`🔌 Socket conectado con ID: ${newSocket.id}`);
    // });

    // newSocket.on("disconnect", () => {
    //   console.log("❌ Socket desconectado");
    // });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, []);

  return { socket };
};
